import React, { FC, ReactElement } from "react";

import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";

import { ReduxTextField } from "../../../components/Redux/TextField";
import SettingSection from "../../../components/SettingSection";
import {
  getPolicyFormProperty,
  setPolicyFormError,
  setPolicyFormProperty,
} from "../../../slices/policies";

export type AdvancedProps = {
  readonly: boolean;
};

export const Advanced: FC<AdvancedProps> = ({ readonly }): ReactElement => {
  return (
    <Container disableGutters maxWidth={false}>
      <SettingSection label="Description" docsKey="policy-description">
        <ReduxTextField
          disabled={readonly}
          fullWidth
          path="description"
          setter={setPolicyFormProperty}
          getter={getPolicyFormProperty}
          errorHandler={setPolicyFormError}
          multiline
          rows={4}
        />
      </SettingSection>
      <Divider />

      <SettingSection label="Explanation" docsKey="policy-explanation">
        <ReduxTextField
          disabled={readonly}
          fullWidth
          path="explanation"
          setter={setPolicyFormProperty}
          getter={getPolicyFormProperty}
          errorHandler={setPolicyFormError}
          multiline
          rows={4}
        />
      </SettingSection>
      <Divider />

      <SettingSection label="Remediation" docsKey="policy-remediation">
        <ReduxTextField
          disabled={readonly}
          fullWidth
          path="remediation"
          setter={setPolicyFormProperty}
          getter={getPolicyFormProperty}
          errorHandler={setPolicyFormError}
          multiline
          rows={4}
        />
      </SettingSection>
    </Container>
  );
};
export default Advanced;
